import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CompanyState {
    companyName: string | null;
    companyLogo: string | null;
    companyEmail?: string | null;
    companyPhone?: string | null;
}

const initialState: CompanyState = {
    companyName: null,
    companyLogo: null,
    companyEmail: null,
    companyPhone: null
};

const companySlice = createSlice({
    name: "company",
    initialState,
    reducers: {
        setCompanyName: (state, action: PayloadAction<string>) => {
            state.companyName = action.payload;
        },
        setCompanyLogo: (state, action: PayloadAction<string | null>) => {
            state.companyLogo = action.payload;
        },
        setCompanyEmail: (state, action: PayloadAction<string | null>) => {
            state.companyEmail = action.payload;
        },
        setCompanyPhone: (state, action: PayloadAction<string | null>) => {
            state.companyPhone = action.payload;
        },
        setCompanyData: (state, action: PayloadAction<{ name?: string; logo?: string | null; email?: string | null; phone?: string | null; }>) => {
            if (action.payload.name !== undefined) {
                state.companyName = action.payload.name;
            }
            if (action.payload.logo !== undefined) {
                state.companyLogo = action.payload.logo;
            }
            if (action.payload.email !== undefined) {
                state.companyEmail = action.payload.email;
            }
            if (action.payload.phone !== undefined) {
                state.companyPhone = action.payload.phone;
            }
        }
    }
});

export const { setCompanyName, setCompanyLogo, setCompanyEmail, setCompanyPhone, setCompanyData } = companySlice.actions;
export default companySlice.reducer;